import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Common from "../../../store/common";
import parse from "html-react-parser";
import * as packageUpgradeDowngradeAction from "../../../store/packageUpgradeService/actions";
import * as BreachActions from "../../../store/breachService/actions";
import { IPackage } from "../../../store/protectionPlanService/ezs/types";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../../store";
import * as LoginActions from "../../../store/loginService/actions";
import { useHistory } from "react-router-dom";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import * as services from "../../../store/service";
import * as BillingStatusActions from "../../../store/BillingStatusService/actions";
interface IProps {
    closeDialog: any;
    dialogId: string;
    billingLabel: string;
    billingAmount: number;
    billingText: string;
    subscriptionType: string;
    subscriptionCharge: string;
    salesTax: string;
    selectedPackage: IPackage;
    subscriptionTypeChange: boolean;
    newCharge: string;
    isTwoStepCancellation: boolean;
    isBfsCancelFlow?: boolean;

}
const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
const ProtectionPlanUpgradeCompleteDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const requestPackageData = () => dispatch(packageUpgradeDowngradeAction.actionCreators.requestPackageData());
    const requestServiceCatalog = () => dispatch(BreachActions.actionCreators.requestBreachService());
    const closeUpgradeCompleteDialog = () => {
        dispatch(Common.actionCreators.refreshUserPermission(true));
        requestPackageData();
        requestServiceCatalog();
        dispatch(BillingStatusActions.actionCreators.getBillingStatus(true));
        props.closeDialog();
    };
    const { t: tLang } = useTranslation();

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                let isTwoStepCancel = sessionStorage.getItem("twoStepCancel");
                if (isTwoStepCancel !== "true") {
                    closeUpgradeCompleteDialog();
                } else {
                    requestLogout(evt);
                }
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });
    const renderBillingLabel = () => {
        return (
            <fieldset className="form-row inline">
                <div className="row data-row">
                    <div className="col-xs-12 col-sm-5 col-no-gutter">
                        <div className="data-label" id="label-todays-charge">
                            <h4 className="status-good">{props.billingLabel}</h4>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                        <div role="region" className="data-value">
                            <h4 className="status-good">
                                {/* to solve bug 23184 */}$
                                {props.selectedPackage?.PartnerId === 428 ? Number(props.subscriptionCharge) : Number(props.billingAmount).toFixed(2)}
                            </h4>
                        </div>
                    </div>
                </div>
            </fieldset>
        );
    };

    const sendTwoStepCancellationEvent = () => {
        services.TwoStepCancellationEvent();
    };
    const sendGeneralCancellationEvent = () => {
        services.GeneralCancellationEvent();
    };

    const redirectToHome = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerModes &&
            state.configurationState.configuration.partnerConfig.partnerModes?.indexOf("PartnerMode.LoginOption.None") > 0
        ) {
            return true;
        }
        return false;
    });

    const originalSiteUrl: any = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.originSiteUrl
        ) {
            return state.configurationState.configuration.partnerConfig.originSiteUrl;
        } else {
            return "";
        }
    });

    const requestLogout = (event: any) => {
        event.preventDefault();
        if (redirectToHome) {
            dispatch(LoginActions.actionCreators.logout(history, originalSiteUrl));
        } else {
            dispatch(LoginActions.actionCreators.logout(history));
        }
        dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
        sessionStorage.setItem("twoStepCancel", "false");
    };

    const dialogTitle = () => {
        if (props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && props.isTwoStepCancellation === true) {
            return tLang("manageAccount.protectionPlan.twoStepCancellation.Title");
        } else {
            return tLang("manageAccount.protectionPlan.thankYou");
        }
    };

    const dialogContent = () => {
        if ((props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && props.isTwoStepCancellation === true) || props.isBfsCancelFlow) {
            return (
                <React.Fragment>
                    <p>{tLang("manageAccount.protectionPlan.twoStepCancellation.Text1")}</p>
                    <p>{tLang("manageAccount.protectionPlan.twoStepCancellation.Text2")}</p>
                </React.Fragment>
            );
        } else {
            return parse(props.billingText);
        }
    };

    const confirmButtonTitle = () => {
        if (props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && props.isTwoStepCancellation === true) {
            return tLang("manageAccount.protectionPlan.twoStepCancellation.btn.LogOut");
        } else {
            return tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.close");
        }
    };

    const confirmButtonAction = (event: any) => {
        if (props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && props.isTwoStepCancellation === true) {
            sendTwoStepCancellationEvent();
            requestLogout(event);
            window.addToDataLayer({ event: "Protection Plan - Completion Log Out" });
        } else {
            if (props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
                sendGeneralCancellationEvent();
            }
            window.addToDataLayer({ event: "Protection Plan - Close completion" });
            closeUpgradeCompleteDialog();
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>{dialogTitle()}</h1>
            </div>

            <div className="dialog-body">
                <div className="form-row inline row">
                    <p>{dialogContent()}</p>
                </div>
              {!props.isBfsCancelFlow && 
               <div> 
                <div className="line-divider margin-vertical-xs"></div>

                <div className="form-row data-grid has-lines row-height-sm">
                    {Number(props.salesTax) ? (
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-5 col-no-gutter">
                                    <div className="data-label" id="label-plan-cost">
                                        <h5>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.planCost")}</h5>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <div className="data-value">
                                        <h5>{formatter.format(Number(props.newCharge))}</h5>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    ) : null}
                    {Number(props.salesTax) ? (
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-5 col-no-gutter">
                                    <div className="data-label" id="label-sales-tax">
                                        <h5>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.salesTax")}</h5>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <div className="data-value">
                                        <h5>${Number(props.salesTax).toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    ) : null}
                    {props.subscriptionType && props.subscriptionCharge && props.billingLabel !== props.subscriptionType ? (
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-5 col-no-gutter">
                                    <div className="data-label" id="label-subscription-type">
                                        <h5>{props.subscriptionType}</h5>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <div className="data-value">
                                        <h5>
                                            {Number(props.salesTax)
                                                ? "$" + (Number(props.subscriptionCharge) + Number(props.salesTax)).toFixed(2)
                                                : "$" + Number(props.subscriptionCharge).toFixed(2)}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    ) : null}
                    {props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" ? renderBillingLabel() : null}
                </div>
                {props.selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" || props.isBfsCancelFlow ? null : renderBillingLabel()}
            </div>}
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="submit"
                            className="btn-default btn-primary"
                            id="btn-submit-purchase"
                            onClick={(e) => {
                                confirmButtonAction(e);
                            }}
                        >
                            <span className="btn-text">{confirmButtonTitle()}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default ProtectionPlanUpgradeCompleteDialog;
